import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap styles
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Import Bootstrap JS (for tooltips to work)
import AuthUser from '../AuthUser';
const ViewMoreDetailsforAnnuityQuotes = (props) => {
  const { http, getUser } = AuthUser()
  let userdetails = getUser()
  const [annuity, setAnnuity] = useState({})
  const [annuitybenef, setAnnuitybenef] = useState([])
  const [annuityinvestinfo, setAnnuityinvertinfo] = useState([])
  useEffect(() => {
    if (props.id) {
      http.get(`admin/viewAnnuity/${userdetails.email}?id=${props.id}`)
        .then((response) => {
          console.log(response.data)
          setAnnuity(response.data.annuity)
          setAnnuitybenef(response.data.annuitybenef)
          setAnnuityinvertinfo(response.data.annuityinvestinfo)
        })
        .catch(function (error) {

        })
    }
  }, [props.id])
  return (
    <Container >
      <Row>

        <Col sm={12}>


          <Container className='m-auto'>
            <Form >

              <Row style={{ backgroundColor: '#E3E0EB' }} className='p-2'>
                <Col sm={11} className='fw-bold'>Personal Information</Col>
                <Col sm={1}></Col>
              </Row>
              <Row className='mt-2 p-2'>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>First Name</strong></p>
                  <span>{annuity.firstname}</span>
                </Col>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Middle Name</strong></p>
                  <span>{annuity.middlename}</span>
                </Col>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Middle Name</strong></p>
                  <span>{annuity.lastname}</span>
                </Col>
              </Row>
              <Row className='mt-2 p-2'>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Date of Birth</strong></p>
                  <span>{annuity.dateofbirth}</span>
                </Col>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Gender</strong></p>
                  <span>{annuity.gender}</span>
                </Col>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Marital Status</strong></p>
                  <span>{annuity.maritalstatus}</span>
                </Col>
              </Row>
              <Row className='mt-2 p-2'>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Social Security Number (SSN)</strong></p>
                  <span>{annuity.ssnno}</span>
                </Col>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Phone Number</strong></p>
                  <span>{annuity.phoneno}</span>
                </Col>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Email Address</strong></p>
                  <span>{annuity.email}</span>
                </Col>
              </Row>

              <Row className='mt-2 p-2'>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Street Address</strong></p>
                  <span>{annuity.address}</span>
                </Col>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>City</strong></p>
                  <span>{annuity.city}</span>
                </Col>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>State</strong></p>
                  <span>{annuity.state}</span>
                </Col>
              </Row>
              <Row className='mt-2 p-2'>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>ZIP Code</strong></p>
                  <span>{annuity.zipcode}</span>
                </Col>

              </Row>

              <Row style={{ backgroundColor: '#E3E0EB' }} className='p-2'>
                <Col sm={11} className='fw-bold'>Annuity Type</Col>
                <Col sm={1}></Col>
              </Row>

              <Row className='mt-2 p-2'>
                <Col sm={12}>
                  <p className='p-0 m-0'><strong>Select Annuity Type</strong></p>
                  <span>{annuity.annuitytype}</span>
                </Col>


              </Row>


              <Row style={{ backgroundColor: '#E3E0EB' }} className='p-2'>
                <Col sm={11} className='fw-bold'>Financial Details</Col>
                <Col sm={1}></Col>
              </Row>

              <Row className='mt-2 p-2'>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Desired Investment Amount</strong></p>
                  <span>${annuity.desiredamount}</span>
                </Col>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Income Start Date</strong></p>
                  <span>{annuity.incomestart}</span>
                </Col>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Investment Duration</strong></p>
                  <span>{annuity.duration}</span>
                </Col>
              </Row>


              <Row className='mt-2 p-2'>

                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Payment Frequency</strong></p>
                  <span>{annuity.paymentfreq}</span>
                </Col>
              </Row>


              <Row style={{ backgroundColor: '#E3E0EB' }} className='p-2'>
                <Col sm={11} className='fw-bold'>Annuity Payout Preferences</Col>
                <Col sm={1}></Col>
              </Row>

              <Row className='mt-2 p-2'>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Payout Frequency</strong></p>
                  <span>{annuity.payoutpref}</span>
                </Col>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Payout Option</strong></p>
                  <span>{annuity.payoutoption}</span>
                </Col>

              </Row>


              <Row style={{ backgroundColor: '#E3E0EB' }} className='p-2'>
                <Col sm={11} className='fw-bold'>Beneficiary Information</Col>
                <Col sm={1}></Col>
              </Row>
              {annuitybenef.map((beneficiary, index) => (
                <Row className="mt-2 p-2">
                  <Col sm={3}>
                    <p className="p-0 m-0">
                      <strong>Contingent Beneficiary</strong>
                    </p>
                    <span>{beneficiary.name} </span>
                  </Col>
                  <Col sm={3}>
                    <p className="p-0 m-0">
                      <strong>Percentage</strong>
                    </p>
                    <span>{beneficiary.percentage}</span>
                  </Col>
                  <Col sm={3}>
                    <p className="p-0 m-0">
                      <strong>Date of Birth</strong>
                    </p>
                    <span>{beneficiary.dob}</span>
                  </Col>
                  <Col sm={3}>
                    <p className="p-0 m-0">
                      <strong>Relation</strong>
                    </p>
                    <span>{beneficiary.relation}</span>
                  </Col>
                </Row>
              ))}



              <Row style={{ backgroundColor: '#E3E0EB' }} className='p-2'>
                <Col sm={11} className='fw-bold'>Retirement and Financial Goals</Col>
                <Col sm={1}></Col>
              </Row>

              <Row className='mt-2 p-2'>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Primary Goals for this Annuity</strong></p>
                  <span>{annuity.goals}</span>
                </Col>


              </Row>



              <Row style={{ backgroundColor: '#E3E0EB' }} className='p-2'>
                <Col sm={11} className='fw-bold'>Risk Tolerance</Col>
                <Col sm={1}></Col>
              </Row>

              <Row className='mt-2 p-2'>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Risk Tolerance</strong></p>
                  <span>{annuity.risk} </span>
                </Col>


              </Row>

              <Row style={{ backgroundColor: '#E3E0EB' }} className='p-2'>
                <Col sm={11} className='fw-bold'>Existing Insurance & Investment Information</Col>
                <Col sm={1}></Col>
              </Row>

              <Row className='mt-2 p-2'>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Do you currently have any existing annuities?</strong></p>
                  <span>{annuity.existannuity} </span>
                </Col>
              </Row>
              {annuity.existannuity === "Yes" && (
                <>
                  {annuityinvestinfo.map((annuity, index) => (
                    <Row className="mt-2 p-2">
                      <Col sm={3}>
                        <p className="p-0 m-0">
                          <strong>Type</strong>
                        </p>
                        <span>{annuity.type} </span>
                      </Col>
                      <Col sm={3}>
                        <p className="p-0 m-0">
                          <strong>Issuer</strong>
                        </p>
                        <span>{annuity.issuer} </span>
                      </Col>
                      <Col sm={3}>
                        <p className="p-0 m-0">
                          <strong>Value</strong>
                        </p>
                        <span>{annuity.value}</span>
                      </Col>
                      <Col sm={3}>
                        <p className="p-0 m-0">
                          <strong>Duration</strong>
                        </p>
                        <span>{annuity.duration} </span>
                      </Col>
                    </Row>
                  ))}
                </>
              )}





              <Row style={{ backgroundColor: '#E3E0EB' }} className='p-2'>
                <Col sm={11} className='fw-bold'>Additional Details & Preferences</Col>
                <Col sm={1}></Col>
              </Row>

              <Row className='mt-2 p-2'>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Preferred Contact Method</strong></p>
                  <span>{annuity.contacttype} </span>
                </Col>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Preferred Contact Time</strong></p>
                  <span>{annuity.contacttime}</span>
                </Col>
                <Col sm={4}>
                  <p className='p-0 m-0'><strong>Additional Notes</strong></p>
                  <span>{annuity.additionalnote} </span>
                </Col>

              </Row>



            </Form>
          </Container>
        </Col>
      </Row>

      <Container>

      </Container>

    </Container>

  );


};

export default ViewMoreDetailsforAnnuityQuotes;